import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { syncOgUrl } from "@/lib/seo";

// À chaque route : og:url = URL réelle (les pages avec useSeo gardent la leur — effets enfants posés avant celui-ci).
export const OgUrlSync = () => {
  const { pathname, search } = useLocation();
  useEffect(() => { syncOgUrl(); }, [pathname, search]);
  return null;
};
